import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import {SectionTitle} from '../components/SectionTitle';
import ServiceCard from '../components/ServiceCard';
import { useCompanyData } from '../../shared/contexts/DataContext';
import Header from '../components/Header';
import useMyPagination from '../../shared/logic/useMyPagination';
import MyPagination from '../../shared/components/MyPagination';
import { servicesImage } from '../../shared/logic/imagesFns';
import { textVariant, textClasses } from '../../shared/config';

const Services = () => {
  const { data } = useCompanyData();
  const { t, fontFamily, displayBanner=true, generalTitleFontSize } = data || {};
  const variant = generalTitleFontSize && textVariant?.[generalTitleFontSize] ? textVariant?.[generalTitleFontSize] : textVariant?.['62'];
  
  const fontSizeCls = generalTitleFontSize && textClasses?.[generalTitleFontSize] ? textClasses?.[generalTitleFontSize] : textClasses?.['62'];

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <Header
        image={servicesImage(data)}
        height="600px"
        transparencyColor={'#15476db2'}
        bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
        displayBanner={displayBanner}
        data={data}
        position="relative"
      >
      <div style={{zIndex:1}}>
        <Box pb={7}>
          <Typography
            variant={variant}
            className={fontSizeCls}
            style={{ color: 'white', fontWeight: 'bold',textTransform:'capitalize', fontFamily:'inherit' }}
          >
            {t && t('companyPage.services')}
          </Typography>
        </Box>
      </div>
      </Header>
      <ServicesList services={data.products} t={t} />
    </div>
  );
};

const ServicesList = ({ services, t }) => {
  // const { setPage, count, currentItems } = useMyPagination(services, 6);

  return (
    <Box py={5} width="90%" margin="auto">
      <SectionTitle>{t && t('companyPage.services')}</SectionTitle>
      <Box display="flex" flexWrap="wrap" justifyContent="center">
        {services?.map((item, i) => (
          <ServiceCard key={i} service={item} />
        ))}
      </Box>
      {/* <MyPagination count={count} onChange={setPage} /> */}
    </Box>
  );
};

export default Services;
